import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Edition from "./Edition";
import Spacer from "components/Spacer";
import BuyNowButton from "../BuyNowButton";
import EditionType from "models/EditionType";
import Typography from "@material-ui/core/Typography";
import keyArt from "assets/images/homePage/buyNowSection/standardEditionKeyart.png";
import titleImage from "assets/images/homePage/buyNowSection/standardEditionTitle.png";
import ImageSkeleton from "components/skeletons/ImageSkeleton";
import calculateAspectRatio from "utils/calculateAspectRatio";
import imageSizes from "imageSizes";
import NextGenUpgradeText from "./NextGenUpgradeText";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        title: {
            "& img": {
                width: "65%",
                [theme.breakpoints.down("xs")]: {
                    width: "100%",
                },
            },
        },
    });
});

export default function StandardEdition() {
    const classes = useStyles();

    const textVariant = "body1";

    return (
        <Edition
            keyArt={
                <ImageSkeleton
                    hideBackground
                    aspectRatio={calculateAspectRatio(
                        imageSizes.homePage.buyNowSection.editionKeyart
                    )}
                    src={keyArt}
                />
            }
            editionTitle={
                <div className={classes.title}>
                    <img src={titleImage} alt="Standard Edition" />
                </div>
            }
            placement="left"
        >
            <ul>
                <li>
                    <Typography variant={textVariant}>Full Game</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Snow Limits Content Pack</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Junkyard Playgrounds Update</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>After Dark Playgrounds Update</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Red Bull Revolution Update</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Parts Unknown Playgrounds Update</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>
                        Tricks N Treats Halloween Playgrounds Update
                    </Typography>
                </li>
            </ul>
            <Spacer size={2} />
            <BuyNowButton
                edition={EditionType.STANDARD}
                dialogText={
                    <>
                        <NextGenUpgradeText />
                    </>
                }
            >
                Buy Standard Edition
            </BuyNowButton>
        </Edition>
    );
}
